export default __webpack_public_path__ + "static/media/tick.2ab3f531.svg";